import { UserDto } from "@/types";
import { create } from "zustand";

interface AuthState {
  accessToken: string | null;
  user: UserDto | null;
  isAuthenticated: boolean;

  // Actions
  setAccessToken: (token: string | null) => void;
  setUser: (user: UserDto | null) => void;
  setIsAuthenticated: (authenticated: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  // State
  accessToken: null,
  user: null,
  isAuthenticated: false,

  // Actions
  setAccessToken: (token: string | null) => {
    set({ accessToken: token });
  },

  setUser: (user: UserDto | null) => {
    set({ user });
  },

  setIsAuthenticated: (authenticated: boolean) => {
    set({ isAuthenticated: authenticated });
  },

  clearAuth: () => {
    set({
      accessToken: null,
      user: null,
      isAuthenticated: false,
    });
  },
}));
